import * as React from "react";
import { useState, useEffect } from "react";

import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";

import { DataGrid, GridColDef, GridValueGetterParams } from "@mui/x-data-grid";

/* TOOLBAR */
import SearchIcon from "@mui/icons-material/Search";
import MailIcon from "@mui/icons-material/Mail";
import ChatBubbleIcon from "@mui/icons-material/ChatBubble";
import Tooltip from "@mui/material/Tooltip";
import IconButton from "@mui/material/IconButton";

import Parceiro from "../../components/classes/Parceiro";
import CentroDistribuicao from "../../components/classes/CentroDistribuicao";
import UnidadeArmazenamento from "../../components/classes/UnidadeArmazenamento";
//import Filtro from '../../components/classes/Filtro';

import ParceiroDataset from "../../components/data/parceiroDataset";
import CentroDistribuicaoDataset from "../../components/data/CentroDataset";
import UnidadeArmazenamentoDataset from "../../components/data/UnidadeArmazenamentoDataSet";
import { t } from "i18next";

interface Data {
  id: Number;
  idSKU: String;
  descricao: String;
  centro: String;
  nome: String;
  referencia: String;
  icones: String;
  passos: String;
}

function createData(
  id: Number,
  idSKU: String,
  descricao: String,
  centro: String,
  nome: String,
  referencia: String,
  icones: String,
  passos: String
): Data {
  return {
    id,
    idSKU,
    descricao,
    centro,
    nome,
    referencia,
    icones,
    passos,
  };
}

interface Filtro {
  id: string;
  idSku: string;
  data: Date;
  contrato: string;
  tiposRegistros: string[];
  aderencia: string;
  etapa: string;
}

function formataData(value: Date): String {
  let frmDate: String = "";
  frmDate =
    String(value).substring(8, 10) +
    "/" +
    String(value).substring(5, 7) +
    "/" +
    String(value).substring(0, 4);
  return frmDate;
}

export default function GridFilterDetalhe() {
  const [tab, setTab] = React.useState("Sku");
  const [pageSize, setPageSize] = React.useState(5);
  const [rows, setRows] = React.useState<Data[]>([]);

  const [filtro, setFiltro] = useState<Filtro>();

  const handleChange = (event: React.SyntheticEvent, newValue: string) => {
    setTab(newValue);
  };

  const dados: Data[] = [];

  const columns: GridColDef[] = [
    { field: "id", headerName: "#", width: 45 },
    {
      field: "idSKU",
      headerName: t("global.table.skuCode"),
      width: 100,
      editable: false,
      headerAlign: "center",
      align: "center",
    },
    {
      field: "descricao",
      headerName: t("global.table.description"),
      width: 300,
      editable: false,
      headerAlign: "center",
      align: "left",
    },
    {
      field: "centro",
      headerName: t("global.table.center"),
      width: 100,
      editable: false,
      headerAlign: "center",
      align: "left",
    },
    {
      field: "nome",
      headerName: t("global.table.name"),
      type: "number",
      width: 200,
      editable: false,
      headerAlign: "center",
      align: "left",
    },
    {
      field: "referencia",
      headerName: t("global.table.reference"),
      width: 100,
      editable: false,
      headerAlign: "center",
      align: "left",
    },
    {
      field: "icones",
      headerName: t("global.table.status"),
      width: 250,
      editable: false,
      headerAlign: "center",
      align: "left",
    },
    {
      field: "passos",
      headerName: t("global.table.step"),
      width: 250,
      editable: false,
      headerAlign: "center",
      align: "left",
    },
  ];

  useEffect(() => {
    const skuFound = async () => {
      const idSku = await localStorage.getItem("UnidadeArmazenamentoSel");
      console.log(idSku);
      if (idSku && idSku !== null && idSku !== undefined) {
        new UnidadeArmazenamentoDataset()
          .ListarAtivoId(idSku)
          .then((result) => {
            setRows((): Data[] =>
              result.map((data: any) => {
                console.log(data);
                return createData(0, idSku, "", "", "", "", "", "");
              })
            );
          });
      }
    };
    skuFound();
  }, [tab]);

  return (
    <React.Fragment>
      <div className="insiderContainerFlex">
        <div
          style={{
            width: "100%",
            height: "65vh",
            backgroundColor: "#FFFAFA",
            scrollBehavior: "auto",
          }}
        >
          <DataGrid
            rows={rows}
            columns={columns}
            rowsPerPageOptions={[50, 100, 250, 500]}
            disableSelectionOnClick
          />
        </div>
      </div>
    </React.Fragment>
  );
}
